import React from 'react'
import PropTypes from 'prop-types'

const MockButtons = () => {
  const Button = ({ type, children }) =>
    <p
      style={{ cursor: 'pointer' }}
      onClick={() => mock(`${type}@example.com`)}
    >
      { children }
    </p>

  Button.propTypes = {
    type: PropTypes.string.isRequired,
    children: PropTypes.string.isRequired,
  }

  const mock = (username) => {
    document.getElementById('username').value = username
    document.getElementById('password').value = 'cl3'
  }

  const mocks = [
    'active', 'in_freeze', 'in_cancellation', 'in_trial',
    'presale', 'cancelled', 'cancelled_in_presale', 'cancelled_in_trial',
    'used_freeze', 'scheduled_freeze', 'sepa_payment',
    'pin_only', 'with_nfc', 'no_access', 'with_doc_signed', 'with_doc_unsigned',
  ]

  return (
    <div style={{ marginTop: '100px', fontSize: '12px' }}>
      <h2>Fill in mock users</h2>
      <p>
        Click on a status/attribute below to fill in the login form with credentials for mock members with different types of statuses
      </p>
      { mocks.map(m => <Button key={m} type={m}>{m}</Button>) }
    </div>
  )
}

export default MockButtons
